import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material/";
import CircularProgress from "@mui/material/CircularProgress";
import actions from "../../../../Store/actions";
import { strings } from "../../../../common/i18n";
import MatReactTable from "../../../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";

/**
 * Audit Locations Component
 */
export default () => {
    const { auditsCreate } = useSelector((state) => state);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const { rows, columns } = useColumnsRows();
    const [onrowUpdate, setRowUpdate] = useState(
        auditsCreate.selectedLocations.idx.length === 0 ? true : false
    );

    useEffect(() => {
        // If rows present and check if rowUpdate
        if (rows.length > 0 && onrowUpdate) {
            const selectedLocIdx = [];
            const selectedLocIds = [];
            rows.map((item) => {
                if (item.assetsCount > 0) {
                    selectedLocIds.push(item.location);
                    selectedLocIdx.push(item.id);
                }
            });
            dispatch(
                actions.auditsCreate.create.itemSet({
                    selectedLocations: {
                        idx: selectedLocIdx,
                        ids: selectedLocIds
                    }
                })
            );
            setRowUpdate(false);
        }
    }, [rows, onrowUpdate]);

    useEffect(() => {
        let isMounted = true;
        async function fetchLocationsCount() {
            if (isMounted) setIsLoading(true);
            const branchLocations = auditsCreate.data.reduce((accum, item) => {
                if (item.selected) {
                    accum.push({
                        branch: item.branch,
                        location: item.location
                    });
                }
                return accum;
            }, []);

            await dispatch(
                actions.auditsCreate.create.getCountRequest(branchLocations)
            );
            if (isMounted) setRowUpdate(true);
            if (isMounted) setIsLoading(false);
        }
        fetchLocationsCount();
        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        if (auditsCreate.selectedLocations.idx.length === 0) return;

        const selectedLocationData = auditsCreate.data.reduce((acc, item) => {
            const updItem = { ...item };
            updItem.selected = auditsCreate.selectedLocations.idx.includes(
                item.id
            );
            acc.push(updItem);
            return acc;
        }, []);

        dispatch(
            actions.auditsCreate.create.itemSet({
                data: selectedLocationData
            })
        );
    }, [auditsCreate.selectedLocations.idx]);

    const onSelectionChange = (selectedRowData) => {
        const selectedIndexes = selectedRowData.map((row) => row.id);
        const selectedLocIds = selectedRowData.map((row) => row.location);
        dispatch(
            actions.auditsCreate.create.itemSet({
                selectedLocations: {
                    idx: selectedIndexes,
                    ids: selectedLocIds
                }
            })
        );
    };

    const initialRowSelection = auditsCreate.selectedLocations.idx.reduce(
        (acc, id) => ({ ...acc, [String(id)]: true }),
        {}
    );

    if (isLoading)
        return (
            <Box
                sx={{
                    display: "flex",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <CircularProgress />
            </Box>
        );

    return (
        <MatReactTable
            persistKey="auditCreateLocations"
            columns={columns}
            data={rows}
            loading={false}
            rowSelection={true}
            enableRowSelection={(row) => row.original.assetsCount > 0}
            onSelectionChange={onSelectionChange}
            getRowId={(row) => String(row.id)}
            initialState={{
                rowSelection: initialRowSelection
            }}
            noRowsMessage={strings("messages.noAssets")}
        />
    );
};
